module.exports = __webpack_public_path__ + "static/media/Planet-physio-plus-logo.a37f8af3.webp";